import { LineNotifyClient } from "../lib/oauth2/LineNotify";

export const useLineNotify = () => {
  return {
    client: new LineNotifyClient(),
  };
};
